// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "pro-fullscreen-renderer" + "." + "454e7e21" + ".chunk.min.css";
};